import logo from "Admin/Assets/logo.png";
import { Layout, Menu } from "antd";
import { addItem } from "Redux/Slices/BreadCrumb";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SidebarItems } from "Admin/Config/SidebarItems";
import styles from "./Sidebar.module.scss";
const { Sider } = Layout;

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = window.location.pathname.split("/");
  const [sidebar, setSidebar] = useState(["1"]);
  useEffect(() => {
    if (pathname.length == 2) {
      setSidebar(["1"]);
    } else {
      SidebarItems.map((item) => {
        if (item.paths.includes(pathname[2])) {
          setSidebar([`${item.key}`]);
        }
      });
    }
  }, [window.location.pathname]);

  const handleMenuItemClick = (item) => {
    dispatch(
      addItem({
        key: SidebarItems[item.key - 1].key,
        label: SidebarItems[item.key - 1].label,
        to: SidebarItems[item.key - 1].to,
        name: SidebarItems[item.key - 1].name,
        level: SidebarItems[item.key - 1].level,
      })
    );
    navigate(`/admin${SidebarItems[item.key - 1].to}`);
  };

  return (
    <Sider
      theme="light"
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken) => { }}
      onCollapse={(collapsed, type) => { }}
    >
      <div className={styles["logo"]}>
        <img src={logo} alt="logo" />
      </div>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={sidebar}
        items={SidebarItems}
        onClick={(item) => handleMenuItemClick(item)}
      />
    </Sider>
  );
};

export default Sidebar;
